import { Navigate, Outlet, useLocation } from "react-router-dom";
import AppHeader from "@/components/feature/AppHeader";

export default function AppLayout() {
  const location = useLocation();
  const loggedIn = localStorage.getItem("atr_logged_in") === "1";

  if (!loggedIn) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-100">
      <AppHeader />
      <main className="w-full flex-1">
        <Outlet />
      </main>
      <footer className="w-full border-t border-background-200 bg-background-50 py-5">
        <div className="flex flex-col items-center justify-between gap-2 px-4 text-xs text-foreground-500 md:flex-row md:px-8">
          <span>文章智能打标 © 2026 · 基于大数据的多维度文章智能打标系统</span>
          <span>高效分类 · 多维打标 · 有序归档</span>
        </div>
      </footer>
    </div>
  );
}